"use strict";

/* ---------------- Helpers (NEW) ---------------- */
function safeQuery(root, sel) {
  try { return root ? root.querySelector(sel) : null; } catch { return null; }
}
function safeSetHTML(targetEl, sourceEl) {
  if (targetEl && sourceEl) {
    targetEl.innerHTML = sourceEl.innerHTML;
    return true;
  }
  console.debug('[renderSectionFilter] skip setHTML:', { hasTarget: !!targetEl, hasSource: !!sourceEl });
  return false;
}
function hasRootStyle() {
  try { return typeof root !== 'undefined' && root && root.style; } catch { return false; }
}

const options_collection = {
  collectionsLoadMore: ".collections-load-more",
  rangeSlider: ".price-range .range-slider",
  rangeSliderMin: ".range-slider-min",
  rangeSliderMax: ".range-slider-max",
  minPriceRange: ".min-price-range",
  maxPriceRange: ".max-price-range",
  collectionSidebar: "#CollectionSidebar",
  // broadened a bit for theme variations
  collectionFilterBlocks: ".filter-blocks, .collection-filter-blocks, [data-filter-blocks]",
  productgridcontainer: "#productgridcontainer, .product-grid-container, [data-product-grid]",
  collectionFiltersForm: "#CollectionFiltersForm",
  section: ".sec__collection-main",
};

class BtnFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById("CollectionSidebar");
    this.onOpen = this.onOpen.bind(this);
    this.addEventListener("click", this.onOpen, false);
  }
  onOpen() {
    if (!this.collectionSidebar) return;
    const html = document.documentElement;
    if (!this.classList.contains("open")) {
      this.collectionSidebar.classList.add("open");
      html.classList.add("open-drawer", "open-sidebar");
      if (hasRootStyle() && typeof getScrollBarWidth !== 'undefined' && getScrollBarWidth?.init) {
        root.style.setProperty("padding-right", getScrollBarWidth.init() + "px");
      }
      this.classList.add("open");
    } else {
      this.collectionSidebar.classList.remove("open");
      html.classList.remove("open-drawer", "open-sidebar");
      if (hasRootStyle()) root.style.removeProperty("padding-right");
      this.classList.remove("open");
    }
  }
}
customElements.define("btn-filter", BtnFilter);

class CloseFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById("CollectionSidebar");
    this.onClose = this.onClose.bind(this);
    this.addEventListener("click", this.onClose, false);
  }
  onClose() {
    const html = document.documentElement;
    if (this.collectionSidebar) this.collectionSidebar.classList.remove("open");
    html.classList.remove("open-drawer", "open-sidebar");
    const btn = document.querySelector(".btn-filter");
    if (btn) btn.classList.remove("open");
    if (hasRootStyle()) root.style.removeProperty("padding-right");
  }
}
customElements.define("close-filter", CloseFilter);

class FacetApplyCanvas extends CloseFilter {
  constructor() {
    super();
    // onClose already bound in parent; extra listener is fine but we keep one
  }
}
customElements.define("facet-apply-canvas", FacetApplyCanvas);

class GridMode extends HTMLElement {
  constructor() {
    super();
    this.gridMode = this.gridMode.bind(this);
    this.addEventListener("click", this.gridMode, false);
  }
  gridMode() {
    const view_mode = this.getAttribute("data-grid-mode");
    if (this.classList.contains("active")) return;
    if (view_mode == 1) return;
    for (var item of document.querySelectorAll("grid-mode")) {
      item.classList.remove("active");
    }
    const container_switch = document.querySelector(".container-products-switch");
    if (!container_switch) return;
    this.classList.add("active");
    const data_view_mode = container_switch.getAttribute("data-view-mode");
    if (data_view_mode) container_switch.classList.remove("grid-columns-" + data_view_mode);
    container_switch.setAttribute("data-view-mode", view_mode);
    container_switch.classList.add("grid-columns-" + view_mode);
  }
}
customElements.define("grid-mode", GridMode);

class ViewMode extends HTMLElement {
  constructor() {
    super();
    this.viewMode = this.viewMode.bind(this);
    this.addEventListener("click", this.viewMode, false);
  }
  viewMode() {
    const view_mode = this.getAttribute("data-view");
    if (this.classList.contains("actived")) return;
    var queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam("view", queryString);
    let searchParams;
    if (view_mode == "list") {
      searchParams = queryString.replace("?", "") + "&view=list";
    } else {
      searchParams = queryString.replace("?", "") + "&view=grid";
    }
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
customElements.define("view-mode", ViewMode);

class FilterItem extends HTMLElement {
  constructor() {
    super();
    this.filterItem = this.filterItem.bind(this);
    this.addEventListener("click", this.filterItem, false);
  }
  filterItem() {
    const tip = this.querySelector(".tooltip");
    if (tip) {
      tip.classList.toggle("current-filter");
    } else {
      const li = this.closest("li");
      if (li) li.classList.toggle("current-filter");
    }
    const url = this.getAttribute("data-href");
    if (url) eventCollectionShopify.renderSectionFilter(url);
  }
}
customElements.define("filter-item", FilterItem);

class FacetClearAll extends CloseFilter {
  constructor() {
    super();
    this.filterItem = this.filterItem.bind(this);
    this.addEventListener("click", this.filterItem, false);
  }
  filterItem() {
    const url = this.getAttribute("data-href");
    if (url) eventCollectionShopify.renderSectionFilter(url);
    this.onClose();
  }
}
customElements.define("facet-clear-all", FacetClearAll);

class FilterSort extends HTMLElement {
  constructor() {
    super();
    this.filterSort = this.filterSort.bind(this);
    this.addEventListener("click", this.filterSort, false);
  }
  filterSort() {
    const value = this.getAttribute("value");
    if (!value) return;
    let queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam("sort_by", queryString);
    const searchParams = queryString.replace("?", "") + "&sort_by=" + value;
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
customElements.define("filter-sort", FilterSort);

class SelectSorter extends HTMLElement {
  constructor() {
    super();
    this.activeFilterSort = this.activeFilterSort.bind(this);
    this.addEventListener("click", this.activeFilterSort, false);
  }
  activeFilterSort() {
    const wrapper = this.closest(".select-custom");
    if (!wrapper) return;
    wrapper.classList.toggle("active");
  }
}
customElements.define("select-sorter", SelectSorter);

var eventCollectionShopify = (function () {
  return {
    init: function () {
      this.ionRangeSlider();
      let windowWidth = window.innerWidth;
      if (windowWidth <= 1024) {
        const horizontal = document.querySelector(".horizontal-filter");
        if (horizontal) {
          const collapsible = document.querySelectorAll("collapsible-block");
          collapsible.forEach((e) => {
            e.classList.add("active");
          });
        }
      }
    },

    ionRangeSlider: function () {
      const price_range = document.querySelector(".price-range");
      if (!price_range) return;

      const maxRange = document.querySelector(options_collection.rangeSliderMax);
      const minRange = document.querySelector(options_collection.rangeSliderMin);
      const minPrice = document.querySelector(".min-price-range");
      const maxPrice = document.querySelector(".max-price-range");

      // If any critical element missing, bail safely
      if (!maxRange || !minRange || !minPrice || !maxPrice) return;

      var minPriceRange = 0;
      var maxPriceRange = 0;

      const formEl = document.querySelector(options_collection.collectionFiltersForm);

      const onMinChange = (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        if (!target) return;
        target.value = target.value.replace(',', '');
        if (Number(minRange.min) + Number(target.value) >= 0) {
          if (Number(target.value) > Number(maxRange.max)) {
            minPrice.value = Number(maxRange.max);
          } else {
            minPrice.value = Number(target.value);
          }
        } else {
          minPrice.value = Number(minRange.min);
        }
        if (!formEl) return;
        const formData = new FormData(formEl);
        const params = new URLSearchParams(formData).toString();
        const nameMin = minPrice.getAttribute("name");
        const nameMax = maxPrice.getAttribute("name");
        var queryString = window.location.search;
        queryString = this.removeParam(nameMin, queryString);
        queryString = this.removeParam(nameMax, queryString);
        var searchParams = queryString.replace("?", "") + "&" + params;
        const url = this.renderUrl(searchParams);
        this.renderSectionFilter(url, searchParams);
      };

      const onMaxChange = (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        if (!target) return;
        target.value = target.value.replace(',', '');
        if (Number(maxRange.max) - Number(target.value) >= 0) {
          maxPrice.value = Number(target.value);
        } else {
          maxPrice.value = Number(maxRange.max);
        }
        if (!formEl) return;
        const formData = new FormData(formEl);
        const params = new URLSearchParams(formData).toString();
        const nameMin = minPrice.getAttribute("name");
        const nameMax = maxPrice.getAttribute("name");
        var queryString = window.location.search;
        queryString = this.removeParam(nameMin, queryString);
        queryString = this.removeParam(nameMax, queryString);
        var searchParams = queryString.replace("?", "") + "&" + params;
        const url = this.renderUrl(searchParams);
        this.renderSectionFilter(url, searchParams);
      };

      const onMinInput = (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        if (!target) return;

        if (Number(maxRange.value) - Number(target.value) >= 1) {
          minPrice.value = Number(target.value);
          minPriceRange = Number(target.value) * 100;
        } else {
          target.value = Number(maxRange.value) - 1;
          minPriceRange = (Number(maxRange.value) - 1) * 100;
        }
        const price_format = Shopify.formatMoney(minPriceRange, cartStrings.money_format);
        const minLbl = document.querySelector(".price-lable .min");
        if (minLbl) minLbl.innerHTML = price_format;

        const pr = target.closest(".price-range");
        if (pr) {
          pr.style.setProperty(
            "--range-from",
            (minRange.value / Number(target.getAttribute("max"))) * 100 + "%"
          );
        }
      };

      const onMaxInput = (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        if (!target) return;

        if (target.value - minRange.value >= 1) {
          maxPrice.value = target.value;
          maxPriceRange = Number(target.value) * 100;
        } else {
          target.value = Number(minRange.value) + Number(1);
          maxPriceRange = (Number(minRange.value) + Number(1)) * 100;
        }
        const price_format = Shopify.formatMoney(maxPriceRange, cartStrings.money_format);
        const maxLbl = document.querySelector(".price-lable .max");
        if (maxLbl) maxLbl.innerHTML = price_format;

        const pr = target.closest(".price-range");
        if (pr) {
          pr.style.setProperty(
            "--range-to",
            (maxRange.value / Number(target.getAttribute("max"))) * 100 + "%"
          );
        }
      };

      const minPriceRangeEl = document.querySelector(options_collection.minPriceRange);
      const maxPriceRangeEl = document.querySelector(options_collection.maxPriceRange);
      if (minPriceRangeEl) minPriceRangeEl.addEventListener("change", onMinChange, false);
      if (maxPriceRangeEl) maxPriceRangeEl.addEventListener("change", onMaxChange, false);

      if (minRange) minRange.addEventListener("input", onMinInput, false);
      if (maxRange) maxRange.addEventListener("input", onMaxInput, false);

      document.querySelectorAll(options_collection.rangeSlider).forEach((sliderRange) => {
        sliderRange.addEventListener(
          "change",
          (event) => {
            event.preventDefault();
            if (!formEl) return;
            const formData = new FormData(formEl);
            const params = new URLSearchParams(formData).toString();
            const nameMin = minPrice.getAttribute("name");
            const nameMax = maxPrice.getAttribute("name");
            var queryString = window.location.search;
            queryString = this.removeParam(nameMin, queryString);
            queryString = this.removeParam(nameMax, queryString);
            var searchParams = queryString.replace("?", "") + "&" + params;
            const url = this.renderUrl(searchParams);
            this.renderSectionFilter(url, searchParams);
          },
          false
        );
      });
    },

    removeParam: function (key, sourceURL) {
      if (!key) return sourceURL;
      var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
      if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
      }
      return rtn;
    },

    renderUrl: function (searchParams) {
      const sec = document.querySelector(options_collection.section);
      const sectionId = sec ? sec.dataset.sectionId : "";
      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      return url;
    },

    renderSectionFilter: function (url, searchParams) {
      this.toggleLoading(document.body, true);
      fetch(`${url}`)
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((responseText) => {
          const parsed = new DOMParser().parseFromString(responseText, "text/html");

          if (window.innerWidth <= 1024) {
            // SOURCE nodes (from response)
            const srcFilterBlocks = safeQuery(parsed, options_collection.collectionFilterBlocks);
            const srcGrid = safeQuery(parsed, options_collection.productgridcontainer);

            // TARGET nodes (on current page)
            const dstFilterBlocks = document.querySelector(options_collection.collectionFilterBlocks);
            const dstGrid = document.querySelector(options_collection.productgridcontainer);

            // Safely set innerHTML (no crash if any is null)
            safeSetHTML(dstFilterBlocks, srcFilterBlocks);
            safeSetHTML(dstGrid, srcGrid);

            const sidebar = document.querySelector(options_collection.collectionSidebar);
            if (sidebar && sidebar.classList.contains("open")) {
              const btn = document.querySelector(".btn-filter");
              if (btn) btn.classList.add("open");
            }
          } else {
            const newSection = safeQuery(parsed, options_collection.section);
            const curSection = document.querySelector(options_collection.section);
            if (newSection && curSection) curSection.replaceWith(newSection);
          }

          document.documentElement.classList.remove("hside_opened");
          this.toggleLoading(document.body, false);
        })
        .catch((error) => {
          console.error('[renderSectionFilter] fetch/render failed:', error);
        })
        .finally(() => {
          if (typeof initLazyloadItem === 'function') initLazyloadItem();
          eventCollectionShopify.ionRangeSlider();
        });

      this.updateUrl(url, searchParams);
    },

    toggleLoading: function (event, loading) {
      if (event) {
        if (loading) {
          event.classList.add("start", "loading");
        } else {
          event.classList.add("finish");
          setTimeout(function () {
            event.classList.remove("start", "loading", "finish");
          }, 500);
        }
      }
    },

    updateUrl: function (url, searchParams = false) {
      if (searchParams) {
        const urlUpdate = `${window.location.pathname}?${searchParams}`;
        window.history.pushState({ url: urlUpdate }, "", urlUpdate);
      } else {
        window.history.pushState({ url: url }, "", url);
      }
    },
  };
})();

eventCollectionShopify.init();
